var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#273B7A"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#121149"
    },
    d: "M308.445,506.613c99.231-20.661,177.386-98.766,198.125-197.968L374.555,176.338L226.187,277.33 l17.613,17.613l-106.632,40.431L308.445,506.613z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.4978,
    y1: 423.8696,
    x2: 165.1978,
    y2: 423.8696,
    gradientTransform: "matrix(1.7239 0 0 -1.7239 35.4714 986.7104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F3F1E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E3E0D0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M358.538,169.52H153.46c-12.278,0-22.316,10.049-22.316,22.319v128.326 c0,12.262,10.037,22.313,22.316,22.313h205.078c12.278,0,22.318-10.05,22.318-22.313V191.84 C380.856,179.571,370.816,169.52,358.538,169.52z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5B4B0"
    },
    points: "255.073,289.797 162.109,340.137 162.261,342.48 256.157,291.868  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5B4B0"
    },
    d: "M360.431,190.857l-59.566,45.87l-44.709,55.143l90.905,50.612h11.476 c8.242,0,15.46-4.534,19.328-11.23l-7.697-51.131L360.431,190.857z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD4B40"
    },
    d: "M256.157,291.868l124.699-96.547v-3.481c0-12.271-10.038-22.319-22.318-22.319h-4.965l-94.441,80.618 l-98.256-80.618h-7.416c-12.278,0-22.316,10.049-22.316,22.319v128.326c0,12.262,10.037,22.313,22.316,22.313h8.801V217.347 L256.157,291.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A43026"
    },
    d: "M380.856,320.165V195.32l-33.794,26.164v120.994h11.476 C370.816,342.48,380.856,332.429,380.856,320.165z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.12ff1c50e68f1dc1b5a9584240d2b920.svg";
export { ForwardRef as ReactComponent };